import BaseApi from '../BaseApi';
import { StatisticApiConverter } from './StatisticApiConverter';

class StatisticApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin/user`;
    this.converter = new StatisticApiConverter();
  }

  getStatistic = ({ formData, id }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/statistic/`,
      formData,
      undefined,
      this.converter.convertStatistic,
    );
}

export default StatisticApi;
